
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 12H2v.5a.5.5 0 01-1 0V7a1 1 0 012 0v2h10V7a1 1 0 012 0v5.5a.5.5 0 01-1 0V12zm-1-4H4V7a2 2 0 00-2-2V4a2 2 0 012-2h8a2 2 0 012 2v1a2 2 0 00-2 2z"}})])
          )
        }
      }
    